'use strict';

angular.module('app.advertiserDropdownList', [])

.controller('advertiserDropdownListCtrl', ['$scope', '$rootScope', '$http', '$state', function ($scope, $rootScope, $http, $state) {
        
    $scope.currentUser = $rootScope.currentUser;

    if($scope.currentUser.accessibility.leftMenu.showCurrentlyManaging) {
    	if($scope.currentUser.role.accessLevel == 'admin'){
	        var url = $rootScope.apiUrl + 'admin/GetAllAdvertiser';
            $http.get(url, {loader: false}).
                success(function (response) {
                    $scope.advertisers = response.data;
                    if(!$scope.selectedAdvertiser) {
                        $scope.advertisers[0].ticked = true;
                        $scope.selectedAdvertiser = $scope.advertisers[0].id;
                        $rootScope.sideMenuSelections.advertiserId = $scope.advertisers[0].id;
                        $rootScope.autoSelectProject = true;
                    } 
                }).error(function (response) {
                    $scope.advertisers = [];
                });
	    } else {
            var url = $rootScope.apiUrl + 'common/getGoverningAgencyByAgency/' + $scope.currentUser.company.id;
            $http.get(url, {loader: false}).
                success(function (response) {
                    $scope.advertisers = response.data;
                    if(!$scope.selectedAdvertiser) {
                        $scope.advertisers[0].ticked = true;
                        $scope.selectedAdvertiser = $scope.advertisers[0].id;
                        $rootScope.autoSelectProject = true;
                    } 
                }).error(function (response) {
                    $scope.advertisers = [];
                });
	    }
    } 

    $scope.searchAdvertisers = function(event) {
        if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
            for(var i = 0; i < $scope.advertisers.length; i++) {
                if($scope.advertisers[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                    var checkbox = $("#selectAdvertiser > .checkboxLayer.show .checkBoxContainer")
                    var item = checkbox.find('label')[i];
                    checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                    break;
                }
            }
        }
    }

    $scope.clearSelection = function() {
        $(".kws ul li a").removeClass("active");
        $(".influencers ul li a").removeClass("active");
        $(".preferred ul li").removeClass('activePreferred');

        $('.main-sidebar .projects .nav-sidebar .project .kws li a').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('not-selected');
        $('.main-sidebar .projects .nav-sidebar .project .kws').hide();

        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers li a').removeClass('active');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('active');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('not-selected');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers').hide();

        $('.main-sidebar .campaigns .nav-sidebar .campaign').removeClass('active');
    }

    $scope.$on('reload_listadvertise', function() {
    	var url = $rootScope.apiUrl + 'admin/GetAllAdvertiser';
        $http.get(url, {loader: false}).
            success(function (response) {
                $scope.advertisers = response.data;
            }).error(function (response) {
                $scope.advertisers = [];
            });
    });


    $scope.$watch('selectedAdvertiser', function(newValue, oldVaule){
        if(newValue !== oldVaule && newValue !== undefined)
        {
        	if(newValue.length > 0 && newValue[0].id != null) {
        		var newAdvertiserId = newValue[0].id;

                $scope.clearSelection();

        		$rootScope.saveParams = null;
                $rootScope.sideMenuSelections.advertiserId = newAdvertiserId;
                $rootScope.$broadcast('clearSelection');
        		$rootScope.$broadcast('refreshReportList', { advertiserId : newAdvertiserId });
	            $rootScope.$broadcast('reload_advertiserProjectList', { advertiserId : newAdvertiserId });
    	        $rootScope.$broadcast('reload_advertiserPreferredList', { advertiserId : newAdvertiserId });
                $rootScope.$broadcast('reload_influencerGroup', { advertiserId : newAdvertiserId });
                $rootScope.$broadcast('reload_campaignList', { advertiserId : newAdvertiserId });
        	}
        }
    });
}]);